module.exports = __webpack_public_path__ + "f78f8338ceffe0f4d1f72d7e2019a8a2.jpg";